'use client';
import { createContext } from 'react';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';

const FileInputContext = createContext(void 0);
const useFileInputContext = ()=>useNonNullishContext(FileInputContext);

export { FileInputContext, useFileInputContext };
